import { defineComponent as _defineComponent } from 'vue';
import { createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    "data-testid": "catalog-card-skeleton",
    class: "flex flex-col rounded-2xl border border-ewhite-200 bg-white p-3 shadow-[0_1px_3px_rgba(0,0,0,0.03)]"
};
export default /*@__PURE__*/ _defineComponent({
    __name: 'ServiceCatalogCardSkeleton',
    setup(__props) {
        // Presentational loading placeholder that mirrors the catalog card layout so the
        // grid does not reflow when data arrives.
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
                    _createStaticVNode("<div class=\"aspect-[20/19] w-full animate-pulse rounded-xl bg-eblack-100\"></div><div class=\"flex flex-col gap-2.5 px-0.5 pt-3\"><div class=\"flex items-start justify-between gap-2\"><div class=\"h-4 w-3/5 animate-pulse rounded-md bg-eblack-100\"></div><div class=\"h-4 w-10 animate-pulse rounded-md bg-eblack-100\"></div></div><div class=\"h-3.5 w-4/5 animate-pulse rounded-md bg-eblack-100\"></div><div class=\"h-3.5 w-2/5 animate-pulse rounded-md bg-eblack-100\"></div><div class=\"mt-2 flex items-center justify-between border-t border-ewhite-200/80 pt-3\"><div class=\"h-4 w-16 animate-pulse rounded-md bg-eblack-100\"></div><div class=\"h-6 w-24 animate-pulse rounded-full bg-eblack-100\"></div></div></div>", 2)
                ]))]));
        };
    }
});
